import React from "react";
import { Button, Image, Typography } from "antd";
import verifyFailureIcon from "../../assets/img/icon-failure.png";
import styles from "./signup.module.css";

const VerifyFailure = () => (
  <div className={styles.auth_signup_page}>
    <div className={styles.auth_wrapper}>
      <div className={styles.signup_success_wrapper}>
        <Image preview={false} src={verifyFailureIcon} />
        <Typography.Title level={3}>
          Email Verification Unsuccessful
        </Typography.Title>
        <Typography.Paragraph>
          Please verify your registered email address with the link in the
          verification email we have sent. If it is not in your Inbox, please
          check your Spam/Junk folder.
        </Typography.Paragraph>
        <Button type="link" href="/signup" className={styles.btn_signup}>
          Retry Again
        </Button>
      </div>
    </div>
  </div>
);

export default VerifyFailure;
